var map = {
	"./ca-AD.json": 1470,
	"./ca-ES.json": 1471,
	"./en-US.json": 1472,
	"./es-AR.json": 1473,
	"./es-CL.json": 1474,
	"./es-CO.json": 1475,
	"./es-ES.json": 1476,
	"./es-MX.json": 1477,
	"./eu-ES.json": 1478,
	"./fr-FR.json": 1479,
	"./it-IT.json": 1480
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1469;


//////////////////
// WEBPACK FOOTER
// ./src/locales ^\.\/.*\.json$
// module id = 1469
// module chunks = 22